import type { PropsWithChildren } from "react";
import { cx } from "class-variance-authority";
import { IconButton, type IconButtonProps } from "../../IconButton/IconButton";
import * as styles from "./Header.module.scss";

export type IconActionProps = IconButtonProps;

export const IconAction = ({
  children,
  className,
  ...props
}: IconActionProps) => {
  return (
    <IconButton
      variant="noStyle"
      className={cx(styles.iconAction, className)}
      {...props}
    >
      {children}
    </IconButton>
  );
};

export const Header = ({ children }: PropsWithChildren) => {
  return <div className={styles.header}>{children}</div>;
};

export const Heading = ({ children }: PropsWithChildren) => {
  return <div className={styles.heading}>{children}</div>;
};
